import React, { useState } from 'react'
import { ChevronDown, ChevronUp } from '../../atoms/NewIcons'

const AttributoSelector = ({ setSelectedAttributo, selectedAttributo, Attributi, label }) => {
  const [open, setOpen] = useState(false)
  return (
    <div style={{ position: 'relative' }} className="attributo-selector">
      <p className="attributo-selector__label" onClick={() => setOpen((prev) => !prev)}>
        {label}: <span className="attributo-selector__label-value">{selectedAttributo?.nome}</span>
        <span className="attributo-selector__label-arrow">
          {!open ? (
            <ChevronDown style={{ maxWidth: 30 }} />
          ) : (
            <ChevronUp style={{ maxWidth: 30 }} />
          )}
        </span>
      </p>
      {open && (
        <div style={{ position: 'absolute', top: '20px' }} className="attributo-selector__options">
          {Attributi?.map((attributo) => (
            <p
              className="attributo-selector__label-value"
              onClick={() => {
                setSelectedAttributo(attributo)
                setOpen(false)
              }}
            >
              {attributo?.nome}
            </p>
          ))}
        </div>
      )}
    </div>
  )
}

export default AttributoSelector
